import React from 'react';
import { FP610 } from '../../../services/p251Api';

interface Tab3Props {
  isEditing: boolean;
  getField: (key: keyof FP610) => FP610[keyof FP610];
  setField: (key: keyof FP610, value: FP610[keyof FP610]) => void;
}

const Tab3GrandUnion: React.FC<Tab3Props> = React.memo(({ isEditing, getField, setField }) => {
  return (
    <div className="form-sections">
      <div className="form-section odd">
        <div className="section-tag">GRAND UNION</div>
        <div className="form-grid two-col">
          <label>A/C NO.</label>
          <div>
            <input
              type="text"
              maxLength={30}
              value={String(getField('fp610_31') || '')}
              onChange={e => setField('fp610_31', e.target.value)}
              disabled={!isEditing}
            />
          </div>

          <label>G.U.P/O #</label>
          <div>
            <input
              type="text"
              maxLength={20}
              value={String(getField('fp610_32') || '')}
              onChange={e => setField('fp610_32', e.target.value)}
              disabled={!isEditing}
            />
          </div>

          <label>PROJECT REF.</label>
          <div>
            <input
              type="text"
              maxLength={30}
              value={String(getField('fp610_33') || '')}
              onChange={e => setField('fp610_33', e.target.value)}
              disabled={!isEditing}
            />
          </div>
        </div>
      </div>
    </div>
  );
});

Tab3GrandUnion.displayName = 'Tab3GrandUnion';
export default Tab3GrandUnion;
